import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const Download = lazyWithPreload(() => import('./Download'))
export const WellhubDownload = lazyWithPreload(
  () => import('./WellhubDownload'),
)
